var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.40273 13.2983H2.92313C2.22962 13.2983 1.66666 13.8514 1.66666 14.5328C1.66666 15.2132 2.22962 15.7672 2.92313 15.7672H8.40273C9.09624 15.7672 9.6592 15.2132 9.6592 14.5328C9.6592 13.8514 9.09624 13.2983 8.40273 13.2983Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3333 5.31556C18.3333 4.63512 17.7704 4.08203 17.0778 4.08203H11.5982C10.9047 4.08203 10.3417 4.63512 10.3417 5.31556C10.3417 5.99691 10.9047 6.55 11.5982 6.55H17.0778C17.7704 6.55 18.3333 5.99691 18.3333 5.31556Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39811 5.31547C7.39811 6.87102 6.11571 8.13184 4.53238 8.13184C2.94998 8.13184 1.66666 6.87102 1.66666 5.31547C1.66666 3.76082 2.94998 2.5 4.53238 2.5C6.11571 2.5 7.39811 3.76082 7.39811 5.31547Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.4992C18.3333 16.0539 17.0509 17.3147 15.4676 17.3147C13.8852 17.3147 12.6019 16.0539 12.6019 14.4992C12.6019 12.9437 13.8852 11.6829 15.4676 11.6829C17.0509 11.6829 18.3333 12.9437 18.3333 14.4992Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhite);
export default __webpack_public_path__ + "static/media/filter_white.bf0488209ee82d55cecd4fdff3a27f97.svg";
export { ForwardRef as ReactComponent };